import { render, staticRenderFns } from "./app-icon.vue?vue&type=template&id=1f5a6001&scoped=true&"
import script from "./app-icon.vue?vue&type=script&lang=ts&"
export * from "./app-icon.vue?vue&type=script&lang=ts&"
import style0 from "./app-icon.vue?vue&type=style&index=0&id=1f5a6001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a6001",
  null
  
)

export default component.exports